import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { FileOperationsImplementation } from "@commoncore/implementation/FileOperationsImplementation";
import { GlobalService } from "@commoncore/services/global.service";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { DigiLockerImplementation } from "../implementation/DigiLockerImplementation";

export class DigiLockerController {

  public digiLockerImplRef: any;
  public universalService: any;
  public router: any;
  public http: any;
  public static singleInstance: any = null;
  public listService : any;
  fileOperationsImplementation: any;

  constructor(public globalService: GlobalService) {
    this.digiLockerImplRef = DigiLockerImplementation.getInstance(this.globalService);
    this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
  }

  public static getInstance(globalService): DigiLockerController {
    if (this.singleInstance == null) {
      this.singleInstance = new DigiLockerController(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  public setEnvObjects(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.listService = globalService.getListServiceRef();
  }

  async loginUserOnDigiLocker(){
    var storageType = this.digiLockerImplRef.digiLockerStorageType;
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["sioAuthUrl"] + storageType;
    try{
      this.digiLockerImplRef.setHandler(this.globalService);
      var result = await this.digiLockerImplRef.loginOnDigiLocker(url,storageType);
      return result;
    }catch(err){
      console.log("error in loginUserOnDigiLocker:",err);
      return err;
    }
  }

  async getRespectiveFolderOfDigiLocker(folderKey, isRoot, objectType) {
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsHeadless"] + ENV_CONFIG.commonUrls["linkedApps"] + ENV_CONFIG.commonUrls["metaData"] + "?appcode="+ this.digiLockerImplRef.appCode +
    (folderKey?("&folderKey=" + folderKey):"") + "&page=0&limit=100";
    try{
      var result = await this.digiLockerImplRef.getLinkedAccountDetails(url, isRoot, objectType);
      return result;
    }catch(err){
      console.log("error in fetching linked accounts folder metadata",err);
      return err;
    }
  }

  async fetchDigiLockerDocuments(){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["digiWalletFetchDocsApi"] ;
    try{
      this.digiLockerImplRef.setHandler(this.globalService);
      var result = await this.digiLockerImplRef.fetchDigiLockerDocuments(url);
      return result;
    }catch(err){
      console.log("error in fetchDigiLockerDocuments:",err);
      return err;
    }
  }

  async addDigiLockerDocsToJC() {
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["digiWalletCopyDocsApi"] ;
    try{
      this.digiLockerImplRef.setHandler(this.globalService);
      var result = await this.digiLockerImplRef.addDigiLockerDocsToJC(url);
      return result;
    }catch(err){
      console.log("error in addDigiLockerDocs:",err);
      return err;
    }
  }

  async updateUIAfterPerformingAction(list,executedTask){
    let filesList = this.digiLockerImplRef.documentsList
    if(executedTask == 'TRASH'){ 
      this.listService.deSelectAll(null);
      let updatedList = this.fileOperationsImplementation.updateOnlyTheUIWithoutMonthWiseSegregation(filesList, list, executedTask);
      if(executedTask == 'TRASH'){
        updatedList = this.digiLockerImplRef.updateDeletedDocuments(updatedList,list)
      }
      filesList = updatedList;
      if(updatedList.length == 0){
        this.universalService.emptyTab = true;
      }else{
        this.universalService.emptyTab = false;
      }
    }
  }

}
